import { render, staticRenderFns } from "./MembersArea.vue?vue&type=template&id=a10c11cc"
import script from "./MembersArea.vue?vue&type=script&lang=js"
export * from "./MembersArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports